<template>
  <v-dialog v-model="isOpenDialog" width="1000px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title>THÊM HỌC SINH XIN NGHỈ PHÉP</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card md="12" outlined class="ma-4 elevation-0">
        <AddStudentFilter />
      </v-card>
      <v-card md="12" outlined class="mx-4 mb-6 elevation-0">
        <ListStudents ref="clear" />
      </v-card>
      <hr color="#E0E0E0" />
      <v-card-actions>
        <v-btn class="ma-2" outlined light @click="cancel" width="100px">Hủy</v-btn>
        <v-spacer></v-spacer>
        <div class="pr-4 grey--text">Đã chọn {{ (students || []).length }} học sinh</div>
        <v-btn class="ma-2" dark depressed color="#0D47A1" @click="save()" width="100px">{{ 'Thêm' }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
import AddStudentFilter from '@/modules/tuitionFee/detail-group/dialogAddStudent/StudentFilter'
import ListStudents from '@/modules/post/selectStudentDialog/ListStudents.vue'

export default {
  components: {
    AddStudentFilter,
    ListStudents,
  },
  props: {
    ignoreStudents: Array,
  },
  data() {
    return {
      isOpenDialog: false,
    }
  },
  computed: {
    ...mapState('postCreate', ['students']),
  },
  methods: {
    ...mapMutations('postCreate', ['setSelectedStudent']),

    openDialog() {
      this.isOpenDialog = true
    },
    cancel() {
      this.isOpenDialog = false
    },
    async save() {
      if (this.students[0]) {
        try {
          this.$emit('studentChanged', this.students)
          this.cancel()
        } catch (error) {
          console.log(error)
        }
      } else {
        this.$alert.error('Vui lòng chọn một học sinh!')
        this.$loading.active = false
      }
    },
  },
}
</script>
